import React from 'react'
import { Typography } from '@mui/material'
import { LEGEND_COLOR_MAP_NEW } from '../../../../../constants'
import {
  LhsHeadingWrapper,
  TitlePercentWrapper,
  ProgressBarWrapper,
} from './style'

const ProgressBar = ({ value, color }) => (
  <ProgressBarWrapper className='progressBar'>
    <span className='progressBarFill' style={{ width: `${value}%`, backgroundColor: color }}></span>
  </ProgressBarWrapper>
)

const LhsHeading = ({ row, showExpandAllCTA = false, level }) => {
  return (
    <LhsHeadingWrapper className={level ? `level${level}` : ''}>
      {showExpandAllCTA && (
        <Typography className={`hideP ${showExpandAllCTA ? 'pptSubHeading' : ''}`}>
          {row.title}
        </Typography>
      )}
      <TitlePercentWrapper title={row.title}>
        <span>{row.title}</span>
        <b>{row.per + '%'}</b>
      </TitlePercentWrapper>
      {row?.parentHeading && <Typography className='pptSubHeading'>{row.parentHeading}</Typography>}
      <ProgressBar value={row.per} color={LEGEND_COLOR_MAP_NEW.Total} />
    </LhsHeadingWrapper>
  )
}

export default LhsHeading
